import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Popconfirm, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import { STATUS_FLAG_FIELD } from '../../../common/constants'

import { useUpdateDishesStatusFlagsMutation } from '../../hooks'
import { updateDishRemoveTierOneConfirmationOverride } from '../../redux/actions'
import { selectDishById } from '../../redux/selectors'

const DishTableTierOneStatusCheckbox = ({ dishId, value, isDisabled }) => {
  const dispatch = useDispatch()
  const { showTierOneOverrideConfirmation } = useSelector(state =>
    selectDishById(state, dishId),
  )
  const [updateStatusFlag] = useUpdateDishesStatusFlagsMutation(
    STATUS_FLAG_FIELD.IS_TIER_ONE_DONE,
  )

  const handleChange = useCallback(
    event => updateStatusFlag([dishId], event.target.checked),
    [dishId, updateStatusFlag],
  )

  const handleConfirmWithOverride = useCallback(
    () => updateStatusFlag([dishId], true, true),
    [dishId, updateStatusFlag],
  )

  const handleCancel = useCallback(
    () => dispatch(updateDishRemoveTierOneConfirmationOverride({ id: dishId })),
    [dishId, dispatch],
  )

  return (
    <Popconfirm
      title="This dish still contains a tier one conflict. Are you sure you want to confirm this dish?"
      onConfirm={handleConfirmWithOverride}
      onCancel={handleCancel}
      okText="Yes"
      cancelText="No"
      visible={showTierOneOverrideConfirmation}
    >
      <Tooltip title="Set dish tier one done">
        <Checkbox
          checked={value}
          onChange={handleChange}
          disabled={isDisabled}
        />
      </Tooltip>
    </Popconfirm>
  )
}

DishTableTierOneStatusCheckbox.propTypes = {
  dishId: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
}

DishTableTierOneStatusCheckbox.defaultProps = {
  isDisabled: false,
}

export default DishTableTierOneStatusCheckbox
